import apiClient from "../lib/api-client";

const handleAPIService = async (
  url,
  method = "POST",
  dataContent = null,
  setProgress = () => { },
  id = null,
  maxpage = null
) => {
  try {
    const isFormData = dataContent instanceof FormData;

    const axiosConfig = {
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total && typeof setProgress === "function") {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        }
      },
    };

    if (!isFormData) {
      axiosConfig.headers = { "Content-Type": "application/json" };
    }

    let response;
    const finalUrl = id ? `${url}/${id}` : url;

    switch (method.toUpperCase()) {
      case "POST":
        response = await apiClient.post(url, dataContent, axiosConfig);
        break;
      case "PUT":
        response = await apiClient.put(finalUrl, dataContent, axiosConfig);
        break;
      case "PATCH":
        response = await apiClient.patch(finalUrl, dataContent, axiosConfig);
        break;
      case "DELETE":
        response = await apiClient.delete(finalUrl, {
          ...axiosConfig,
          data: dataContent || {},
        });
        break;
      case "GET":
        response = await apiClient.get(url, {
          ...axiosConfig,
          params: dataContent || {},
        });
        break;
      default:
        throw new Error(`Unsupported method: ${method}`);
    }

    return { data: response.data, error: null };
  } catch (error) {
    // Error logic is already handled by interceptors in apiClient
    return {
      data: null,
      error: error.message,
    };
  }
};

export default handleAPIService;
